import React, { useEffect } from "react";
import { Container, TableHead } from "@mui/material";
import { useJwtStorage, useLocalStorage } from "../../hooks/useLocalStorage";
import dayjs from "dayjs";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";

import Paper from "@mui/material/Paper";

import DrawerAppBar from "../../components/DrawerAppBar";
import Title from "../../components/Title";
import ProgressBar from "../../components/ProgressBar";

import { getStudentComments } from "../../services/UserService";

const StudentComments = () => {
  const [_jwt] = useJwtStorage();
  const [_school] = useLocalStorage("Auth", "school", null);
  const [_showProgress, setShowProgress] = React.useState(false);

  const [_comments, setComments] = React.useState([]);

  useEffect(() => {
    initComments();
  }, []);

  const initComments = () => {
    setShowProgress(true);

    getStudentComments(_school, _jwt)
      .then((results) => {
        setComments(results.data);
      })
      .finally(() => {
        setShowProgress(false);
      });
  };

  return (
    <>
      <DrawerAppBar />

      <Container sx={{ mt: 1 }}>
        <Title text="Student Comments" showBack={true} />
        <ProgressBar showProgress={_showProgress} />

        <TableContainer component={Paper} sx={{ mt: 2 }}>
          <Table sx={{ minWidth: 400 }} aria-label="score totals table">
            <TableHead>
              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell>Teacher</TableCell>
                <TableCell>Comment</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {_comments.length === 0 && (
                <TableRow>
                  <TableCell colSpan={10}>-- NO RESULTS RETURNED --</TableCell>
                </TableRow>
              )}

              {_comments.map((comment) => (
                <TableRow>
                  <TableCell>
                    {dayjs(comment.date).format("MM/DD/YYYY hh:mm a")}
                  </TableCell>
                  <TableCell>
                    {comment.teacherLastName}, {comment.teacherFirstName}
                  </TableCell>
                  <TableCell>
                    <b>{comment.commentText}</b>
                    {comment.comment}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Container>
    </>
  );
};

export default StudentComments;
